export default __webpack_public_path__ + "media/images/svg/in-icon-b04d67fbbd8258c21d0278e720a84aa5.svg";